/*
===========================================
Premium Testimonials
Shopify OS 2.0
===========================================
*/

(() => {

  'use strict';

  function initTestimonials(container = document) {

    const sliders = container.querySelectorAll('.testimonialSwiper');

    sliders.forEach((slider) => {

      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }

      const section = slider.closest('.ajs-testimonials');

      if (!section) return;

      const autoplayEnabled =
        section.dataset.autoplay === 'true';

      const autoplaySpeed =
        parseInt(section.dataset.speed || '5000', 10);

      const showPagination =
        section.dataset.pagination !== 'false';

      const showNavigation =
        section.dataset.navigation !== 'false';

      new Swiper(slider, {

        slidesPerView: 1,

        spaceBetween: 30,

        speed: 700,

        loop: true,

        grabCursor: true,

        watchOverflow: true,

        observer: true,

        observeParents: true,

        autoHeight: false,

        autoplay: autoplayEnabled
          ? {
              delay: autoplaySpeed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,

        pagination: showPagination
          ? {
              el: section.querySelector('.ajs-pagination'),
              clickable: true
            }
          : false,

        navigation: showNavigation
          ? {
              nextEl: section.querySelector('.ajs-next'),
              prevEl: section.querySelector('.ajs-prev')
            }
          : false,

        breakpoints: {

          0: {
            slidesPerView: 1,
            spaceBetween: 20
          },

          768: {
            slidesPerView: 1,
            spaceBetween: 30
          },

          992: {
            slidesPerView: 1,
            spaceBetween: 40
          }

        }

      });

    });

  }

  document.addEventListener('DOMContentLoaded', () => {
    initTestimonials();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initTestimonials(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    initTestimonials();
  });

  document.addEventListener('shopify:block:select', (event) => {

    const slide = event.target.closest('.swiper-slide');

    if (!slide) return;

    const swiper = slide.closest('.testimonialSwiper')?.swiper;

    if (!swiper) return;

    swiper.slideToLoop(slide.dataset.swiperSlideIndex || 0);

  });

})();